<div class="page-topbar sidebar_shift">
  <!-- START LOGO AREA -->
  <div class="logo-area">
  </div>
  <!-- END LOGO AREA -->
</div>
<!-- START CONTAINER -->
<div class="page-container row-fluid container-fluid">
  <section id="main-content" class="sidebar_shift">
    <section class="wrapper main-wrapper row">
      <table class="table table-condensed">
        <tr *ngFor="let source of User.Sources" class="row">
          <td class="col-md-2">
            <label>{{source.SourceCode}}</label>
          </td>
          <td class="col-md-4">{{source.SourceName}}</td>
          <td class="col-md-1">
            <input type="button" value="select" (click)="selectSource(source)" class="btn btn-success form-control" />
          </td>
        </tr>
      </table>
    </section>
  </section>
</div>

